import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/AppLayout";

export default function KnowledgeHistory() {
  const [changes, setChanges] = useState([]);

  useEffect(() => { api.get("/history").then((r) => setChanges(r.data)); }, []);

  return (
    <div>
      <PageHeader title="Knowledge History" subtitle="An immutable, append-only record of how structured knowledge has changed over time. Constitutional history is never silently overwritten." />
      <div className="p-10">
        <div className="max-w-3xl" data-testid="history-list">
          {changes.length === 0 && <div className="text-slate-400 text-sm border border-slate-200 bg-white p-8">No changes recorded yet.</div>}
          <div className="relative border-l border-slate-200 ml-2">
            {changes.map((c) => (
              <div key={c.id} className="relative pl-8 pb-8" data-testid={`history-${c.id}`}>
                <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 bg-slate-900 rounded-full" />
                <div className="bg-white border border-slate-200 p-5">
                  <div className="flex items-center gap-2 flex-wrap mb-2">
                    {c.knowledge_id && <span className="font-mono text-xs text-slate-700 bg-slate-100 px-1.5 rounded-sm">{c.knowledge_id}</span>}
                    <span className="font-mono text-[10px] uppercase tracking-wider text-slate-500 border border-slate-300 px-1.5 py-0.5 rounded-sm">{c.change_type?.replace(/_/g, " ")}</span>
                    <span className="font-mono text-[10px] text-slate-400 ml-auto">{new Date(c.approved_at).toLocaleString()}</span>
                  </div>
                  {c.knowledge_title && <div className="font-semibold text-slate-800 text-sm mb-1">{c.knowledge_title}</div>}
                  <p className="text-sm text-slate-600">{c.reason}</p>
                  {c.old_value && (
                    <div className="mt-3 grid grid-cols-1 gap-2 text-xs">
                      <div className="bg-red-50 border border-red-100 p-2 rounded-sm text-red-800"><span className="font-mono uppercase text-[9px] text-red-400">was</span><br />{c.old_value}</div>
                      <div className="bg-emerald-50 border border-emerald-100 p-2 rounded-sm text-emerald-800"><span className="font-mono uppercase text-[9px] text-emerald-500">now</span><br />{c.new_value}</div>
                    </div>
                  )}
                  <div className="text-[10px] font-mono text-slate-400 mt-2">approved by {c.approved_by}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
